import { useEffect, useRef, useState } from "react";
import { CopyOutlined, CheckOutlined, LinkOutlined } from "@ant-design/icons";
import { message } from "antd";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import classes from "./ShareInput.module.css";

/**
 * The shareable link, read-only, with a copy affordance.
 *
 * The path carries /external only once the document has actually been made
 * public, not when the option is merely selected — the link has to describe the
 * access that exists, not the access about to be granted.
 */
export const ShareInput = () => {
  const { id } = useParams();
  const isExternalAllow = useSelector((state) => state.editor.isExternalAllow);
  const [copied, setCopied] = useState(false);
  const resetTimer = useRef(null);
  const sharedUrl = `https://pad.workw.com${isExternalAllow ? "/external" : ""}/${id}`;

  // The confirmation is a timer, so it has to be cancelled if the dialog closes
  // before it fires.
  useEffect(() => () => clearTimeout(resetTimer.current), []);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(sharedUrl);
    } catch (error) {
      message.error("Couldn't copy the link");
      return;
    }
    setCopied(true);
    clearTimeout(resetTimer.current);
    resetTimer.current = setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div className={classes.linkRow}>
      <LinkOutlined className={classes.linkIcon} />
      <span className={classes.linkText} title={sharedUrl}>{sharedUrl}</span>
      {/* Confirms in place rather than through a toast: the button you pressed is
          where you are already looking. */}
      <button
        type="button"
        className={`${classes.copyBtn} ${copied ? classes.copyBtnDone : ''}`}
        onClick={copyLink}
        aria-label="Copy link"
      >
        {copied ? <CheckOutlined /> : <CopyOutlined />}
        <span>{copied ? 'Copied' : 'Copy'}</span>
      </button>
    </div>
  );
};
